import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const EmailSignup = ({ 
  title = "Join the EMBER Community",
  subtitle = "Get weekly insights, leadership practices, and exclusive access to our community of transformational leaders.",
  className = "",
  variant = "inline" // keeping this for compatibility, but will use ConvertKit form
}) => {
  useEffect(() => {
    // Load ConvertKit script
    const script = document.createElement('script');
    script.src = 'https://f.convertkit.com/ckjs/ck.5.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  if (variant === 'inline') {
    return (
      <motion.div 
        className={`max-w-2xl mx-auto text-center ${className}`}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h3 className="text-2xl font-bold mb-4 text-white">{title}</h3>
        <p className="text-neutral-light mb-8">{subtitle}</p>
        
        {/* ConvertKit Form with EMBER styling */}
        <div dangerouslySetInnerHTML={{
          __html: `
            <form action="https://app.kit.com/forms/8170299/subscriptions" class="seva-form formkit-form" method="post" data-sv-form="8170299" data-uid="8b1e942de1" data-format="inline" data-version="5" data-options='{"settings":{"after_subscribe":{"action":"message","success_message":"Success! Now check your email to confirm your subscription.","redirect_url":""},"analytics":{"google":null,"fathom":null,"facebook":null,"segment":null,"pinterest":null,"sparkloop":null,"googletagmanager":null},"modal":{"trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15},"powered_by":{"show":true,"url":"https://kit.com/features/forms?utm_campaign=poweredby&utm_content=form&utm_medium=referral&utm_source=dynamic"},"recaptcha":{"enabled":false},"return_visitor":{"action":"show","custom_content":""},"slide_in":{"display_in":"bottom_right","trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15},"sticky_bar":{"display_in":"top","trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15}},"version":"5"}' min-width="400 500 600 700 800">
              <div data-style="clean">
                <ul class="formkit-alert formkit-alert-error" data-element="errors" data-group="alert"></ul>
                <div data-element="fields" data-stacked="false" class="seva-fields formkit-fields">
                  <div class="formkit-field">
                    <input class="formkit-input" name="email_address" aria-label="Email Address" placeholder="Enter your email" required="" type="email" style="color: #333; border-color: rgba(255, 87, 34, 0.3); border-radius: 8px; font-weight: 400; background: rgba(255, 255, 255, 0.95); padding: 16px; font-size: 16px;">
                  </div>
                  <button data-element="submit" class="formkit-submit formkit-submit" style="background: linear-gradient(135deg, #FFC107, #FF5722, #E91E63); color: white; border-radius: 8px; font-weight: 600; font-size: 16px; padding: 16px 24px; border: none; cursor: pointer; transition: all 0.3s ease;">
                    <div class="formkit-spinner">
                      <div></div><div></div><div></div>
                    </div>
                    <span class="">Subscribe</span>
                  </button>
                </div>
                <div class="formkit-powered-by-convertkit-container">
                  <a href="https://kit.com/features/forms?utm_campaign=poweredby&utm_content=form&utm_medium=referral&utm_source=dynamic" data-element="powered-by" class="formkit-powered-by-convertkit" data-variant="light" target="_blank" rel="nofollow">Built with Kit</a>
                </div>
              </div>
              <style>
                .seva-form[data-uid="8b1e942de1"] {
                  max-width: 600px;
                  margin: 0 auto;
                }
                .seva-form[data-uid="8b1e942de1"] .formkit-fields {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 12px;
                  justify-content: center;
                  align-items: center;
                }
                .seva-form[data-uid="8b1e942de1"] .formkit-field {
                  flex: 1;
                  min-width: 250px;
                }
                .seva-form[data-uid="8b1e942de1"] .formkit-submit {
                  flex-shrink: 0;
                  min-width: 140px;
                }
                .seva-form[data-uid="8b1e942de1"] .formkit-input:focus {
                  outline: none;
                  border-color: #FF5722 !important;
                  box-shadow: 0 0 0 3px rgba(255, 87, 34, 0.2);
                }
                .seva-form[data-uid="8b1e942de1"] .formkit-submit:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 8px 25px rgba(255, 87, 34, 0.3);
                }
                .seva-form[data-uid="8b1e942de1"] .formkit-alert {
                  background: rgba(239, 68, 68, 0.1);
                  border: 1px solid rgba(239, 68, 68, 0.3);
                  border-radius: 8px;
                  color: #dc2626;
                  padding: 12px;
                  margin-bottom: 16px;
                  text-align: center;
                }
                .seva-form[data-uid="8b1e942de1"] .formkit-alert:empty {
                  display: none;
                }
                .seva-form[data-uid="8b1e942de1"] .formkit-powered-by-convertkit-container {
                  margin-top: 16px;
                  opacity: 0.7;
                }
                .seva-form[data-uid="8b1e942de1"] .formkit-powered-by-convertkit {
                  color: rgba(255, 255, 255, 0.8) !important;
                  font-size: 12px;
                  text-decoration: none;
                }
                .seva-form[data-uid="8b1e942de1"] .formkit-powered-by-convertkit:hover {
                  color: white !important;
                }
                @media (max-width: 640px) {
                  .seva-form[data-uid="8b1e942de1"] .formkit-fields {
                    flex-direction: column;
                  }
                  .seva-form[data-uid="8b1e942de1"] .formkit-field,
                  .seva-form[data-uid="8b1e942de1"] .formkit-submit {
                    width: 100%;
                    min-width: auto;
                  }
                }
              </style>
            </form>
          `
        }} />
      </motion.div>
    );
  }

  // Default variant for other cases
  return (
    <motion.div
      className={`bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 max-w-2xl mx-auto ${className}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold mb-2 text-white">{title}</h3>
        <p className="opacity-90 text-neutral-light">{subtitle}</p>
      </div>

      {/* ConvertKit Form with EMBER styling for default variant */}
      <div dangerouslySetInnerHTML={{
        __html: `
          <form action="https://app.kit.com/forms/8170299/subscriptions" class="seva-form formkit-form" method="post" data-sv-form="8170299" data-uid="8b1e942de1" data-format="inline" data-version="5" data-options='{"settings":{"after_subscribe":{"action":"message","success_message":"Success! Now check your email to confirm your subscription.","redirect_url":""},"analytics":{"google":null,"fathom":null,"facebook":null,"segment":null,"pinterest":null,"sparkloop":null,"googletagmanager":null},"modal":{"trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15},"powered_by":{"show":true,"url":"https://kit.com/features/forms?utm_campaign=poweredby&utm_content=form&utm_medium=referral&utm_source=dynamic"},"recaptcha":{"enabled":false},"return_visitor":{"action":"show","custom_content":""},"slide_in":{"display_in":"bottom_right","trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15},"sticky_bar":{"display_in":"top","trigger":"timer","scroll_percentage":null,"timer":5,"devices":"all","show_once_every":15}},"version":"5"}' min-width="400 500 600 700 800">
            <div data-style="clean">
              <ul class="formkit-alert formkit-alert-error" data-element="errors" data-group="alert"></ul>
              <div data-element="fields" data-stacked="false" class="seva-fields formkit-fields">
                <div class="formkit-field">
                  <input class="formkit-input" name="email_address" aria-label="Email Address" placeholder="Enter your email" required="" type="email" style="color: white; border-color: rgba(255, 255, 255, 0.3); border-radius: 8px; font-weight: 400; background: rgba(255, 255, 255, 0.2); padding: 16px; font-size: 16px;">
                </div>
                <button data-element="submit" class="formkit-submit formkit-submit" style="background: linear-gradient(135deg, #FFC107, #FF5722, #E91E63); color: white; border-radius: 8px; font-weight: 600; font-size: 16px; padding: 16px 24px; border: none; cursor: pointer; transition: all 0.3s ease;">
                  <div class="formkit-spinner">
                    <div></div><div></div><div></div>
                  </div>
                  <span class="">Subscribe</span>
                </button>
              </div>
              <div class="formkit-powered-by-convertkit-container">
                <a href="https://kit.com/features/forms?utm_campaign=poweredby&utm_content=form&utm_medium=referral&utm_source=dynamic" data-element="powered-by" class="formkit-powered-by-convertkit" data-variant="light" target="_blank" rel="nofollow">Built with Kit</a>
              </div>
            </div>
            <style>
              .seva-form[data-uid="8b1e942de1"] {
                max-width: 100%;
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-fields {
                display: flex;
                flex-direction: column;
                gap: 16px;
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-field {
                width: 100%;
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-submit {
                width: 100%;
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-input:focus {
                outline: none;
                border-color: rgba(255, 255, 255, 0.8) !important;
                box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-input::placeholder {
                color: rgba(255, 255, 255, 0.7);
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-submit:hover {
                transform: translateY(-2px);
                box-shadow: 0 8px 25px rgba(255, 87, 34, 0.4);
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-alert {
                background: rgba(239, 68, 68, 0.1);
                border: 1px solid rgba(239, 68, 68, 0.3);
                border-radius: 8px;
                color: #fca5a5;
                padding: 12px;
                margin-bottom: 16px;
                text-align: center;
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-alert:empty {
                display: none;
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-powered-by-convertkit-container {
                margin-top: 16px;
                opacity: 0.7;
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-powered-by-convertkit {
                color: rgba(255, 255, 255, 0.8) !important;
                font-size: 12px;
                text-decoration: none;
              }
              .seva-form[data-uid="8b1e942de1"] .formkit-powered-by-convertkit:hover {
                color: white !important;
              }
            </style>
          </form>
        `
      }} />

      <p className="text-xs opacity-70 text-center mt-4 text-white">
        We respect your privacy. Unsubscribe at any time.
      </p>
    </motion.div>
  );
};

export default EmailSignup;